module.exports = __webpack_public_path__ + "static/images/services-empty.16fc50be9b3df927a3a63d6c4e2fcac7.svg";